/**
 * База API: всегда relative /api — nginx внутри Docker проксирует на нужный бэкенд.
 * Для локальной разработки можно переопределить через REACT_APP_API_URL.
 */
export function getAdminApiBaseUrl(): string {
  return process.env.REACT_APP_API_URL || '/api';
}

/** SignalR hub: relative через nginx. */
export function getAdminNotificationsHubUrl(): string {
  return '/hubs/notifications';
}

export function isProductionAdminHost(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.toLowerCase() === 'admin.xchangelab.com';
}
